import * as React from "react";
import { Button } from "../../../ui/components/Button";
import * as authText from "../../../ui/components/Auth/authTypography.style.css";
import * as userApi from "../../lib/api/users";
import { ApiClientError } from "../../lib/api/client";

export interface RemovePhoneContentProps {
  token: string | null;
  onRefreshUser: () => Promise<void>;
  onError: (message: string | null) => void;
  onRemoved?: () => void;
}

export function RemovePhoneContent({
  token,
  onRefreshUser,
  onError,
  onRemoved,
}: RemovePhoneContentProps) {
  const [loading, setLoading] = React.useState(false);

  const handleRemove = async () => {
    if (!token) {
      onError("Session expired. Please sign in again.");
      return;
    }
    setLoading(true);
    onError(null);
    try {
      await userApi.removePhone(token);
      await onRefreshUser();
      onRemoved?.();
    } catch (e) {
      onError(e instanceof ApiClientError ? e.message : "Failed to remove phone number");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <p className={authText.subtitleSpaced} style={{ margin: 0 }}>
        This clears your phone from your account. You will need to verify again to add a new number.
      </p>
      <Button
        type="button"
        color="danger"
        variant="solid"
        fullWidth
        size="lg"
        loading={loading}
        onClick={handleRemove}
      >
        Remove phone
      </Button>
    </div>
  );
}
